module.exports = __webpack_public_path__ + "static/media/icone-checkout-checked.6f24ce49.png";